import { z } from 'zod';
import { chainSchema } from './chain-schema';
import { citySchema } from './city-schema';
import { companySchema } from './company-schema';
import { configurationSchema } from './configuration-schema';
import { countySchema } from './county-schema';
import { imageSchema } from './image-schema';
import { tableOfContentsSchema } from './table-of-contents-schema';

export type TCatalog = z.infer<typeof catalogSchema>;

const positionSchema = z.object({
  component: z.enum([
    'People',
    'Companies',
    'Map',
    'District',
    'City',
    'Products',
    'BasicCompanies',
    'TrustFactors',
  ]),
  variant: z.enum(['default', 'secondary', 'districtPicker']),
});

export type TPosition = z.infer<typeof positionSchema>;

export const catalogSchema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string(),
    contactUrl: z.string().optional().nullable(),
    defaultForm: z.string().optional().nullable(),
    companiesAlias: z.string(),
    language: z.object({
      data: z
        .object({
          attributes: z.object({
            title: z.string(),
            locale: z.string(),
          }),
        })
        .nullable()
        .optional(),
    }),
    cities: z.object({ data: z.array(citySchema) }),
    counties: z.object({ data: z.array(countySchema) }),
    chains: z.object({ data: z.array(chainSchema) }),
    companies: z.object({ data: z.array(companySchema) }),
    configuration: configurationSchema,
    positions: z.array(positionSchema).nullable().optional(),
    defaultBackground: imageSchema,
    defaultTopImage: imageSchema,
    tableOfContents: z.array(tableOfContentsSchema),
  }),
});

export const catalogResponseSchema = z.object({
  data: z.array(catalogSchema),
  meta: z.object({
    pagination: z.object({
      page: z.number(),
      pageSize: z.number(),
      pageCount: z.number(),
      total: z.number(),
    }),
  }),
});

export type CatalogResponse = z.infer<typeof catalogResponseSchema>;
